import React from "react";
import { ConfigColumns2 } from "../../../types/configColumns2";
import { Culture } from "../../../types/culture";
import { translateString } from "../../../translations/gridTranslationHelper";
import { WorkorderManagementBom } from "../../../types/workorderManagementBom";

const yes = (culture: Culture) => <React.Fragment>{translateString("rxg_Yes", culture)}</React.Fragment>;
const no = (culture: Culture) => <React.Fragment>{translateString("rxg_No", culture)}</React.Fragment>;

const workorderManagementBomPaneColumns = (culture: Culture): ConfigColumns2[] => {
    return [
        { data: "woBomId", visible: false, width: "0%", title: "woBomId" },
        {
            data: "materialSapCode",
            className: "nowrap",
            width: "33%",
            title: translateString("material", culture)
        },
        {
            data: "description",
            className: "nowrap",
            width: "33%",
            title: translateString("description", culture)
        },
        {
            data: "backFlush",
            className: "nowrap",
            width: "33%",
            title: translateString("massIssue", culture),
            render: (data: WorkorderManagementBom) => (data.backFlush ? yes(culture) : no(culture))
        },
        {
            data: "isActive",
            className: "nowrap",
            width: "33%",
            title: translateString("isActive", culture),
            render: (data: WorkorderManagementBom) => (data.isActive ? yes(culture) : no(culture))
        }
    ];
};

export { workorderManagementBomPaneColumns };
